export default "__VITE_ASSET__sh5HacYb__"